import "./App.css";
import { Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Home } from "./components/home/Home";
import { Navbar } from "./components/navbar/Navbar";
import { useTheme } from "./contexts/Theme.context";
import { Footer } from "./components/footer/Footer";
import ScrollToTop from "react-scroll-to-top";
import { IoIosArrowUp } from "react-icons/io";
import { ProjectManagement } from "./components/projectManagement/ProjectManagement";
import { Realizations } from "./components/realizations/Realizations";
import { Contact } from "./components/contact/Contact";
import { NotFound } from "./components/404/NotFound";

function App() {
  const { theme, oppositeTheme } = useTheme();
  return (
    <>
      <HelmetProvider>
        <div className={`App ${theme} text-${oppositeTheme}`}>
          <Navbar />
          <Routes>
            <Route index element={<Home />} />
            <Route path="/project-management" element={<ProjectManagement />} />
            <Route path="/realizations" element={<Realizations />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
          <Footer />
          <ScrollToTop
            top={201}
            className="icon"
            smooth
            component={<IoIosArrowUp size={30} color="white" />}
          />
        </div>
      </HelmetProvider>
    </>
  );
}

export default App;
